"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const and_1 = require("../generics/and");
const at_1 = require("../generics/at");
const isFunction_1 = require("./isFunction");
const isLength_1 = require("./isLength");
exports.isArrayLike = and_1.and(at_1.at('length', isLength_1.isLength), (value) => !isFunction_1.isFunction(value));
//# sourceMappingURL=isArrayLike.js.map